import { Message } from '../../MessageBus/Message';


export class ListQuery extends Message
{
    constructor(Folder: string, AttachFilesContent: boolean)
    {
        super("List", { Folder, AttachFilesContent });
    }
}
